import { applyMiddleware, createStore, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import LogRocket from 'logrocket'
import rootReducer from '../reducers'
import rootSaga from '../sagas'
import PersistentStore from './PersistentStore'

const sagaMiddleware = createSagaMiddleware()

const store = createStore(
  rootReducer,
  PersistentStore.get(),
  compose(
    applyMiddleware(sagaMiddleware, LogRocket.reduxMiddleware()),
    window.devToolsExtension
      ? window.devToolsExtension({ trace: true })
      : (f) => f
  )
)

PersistentStore.persist(store)
sagaMiddleware.run(rootSaga)

export default store

// import { applyMiddleware, createStore, compose } from 'redux';
// import createSagaMiddleware from 'redux-saga';
// import LogRocket from 'logrocket';
// import rootReducer from '../reducers';
// import rootSaga from '../sagas';
// import PersistentStore from './PersistentStore';
// import { composeWithDevTools } from 'remote-redux-devtools'; // Import composeWithDevTools

// const sagaMiddleware = createSagaMiddleware();

// const composeEnhancers = composeWithDevTools({ realtime: true }); // Use composeWithDevTools instead of window.devToolsExtension

// const store = createStore(
//   rootReducer,
//   PersistentStore.get(),
//   composeEnhancers(
//     applyMiddleware(sagaMiddleware, LogRocket.reduxMiddleware()),
//   ),
// );

// PersistentStore.persist(store);
// sagaMiddleware.run(rootSaga);

// export default store;
